import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'wonderbly-components/lib/Icon';
import './MenuToggle.scss';

const MenuToggle = props => (
  <button
    onClick={props.handleClick}
    className={cx('menu-toggle', { 'menu-toggle-bigger': props.isNavOpen })}
    type="button">
    <Icon icon={props.isNavOpen ? 'delete' : 'rows'} />
    <span className={cx('menu-toggle-text', { 'menu-toggle-text-hide': props.isNavOpen })}>{props.label}</span>
  </button>
);

MenuToggle.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isNavOpen: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

export default MenuToggle;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/MenuToggle/MenuToggle.js